import React, { useRef, useEffect, useState } from 'react';
import './history.css';
import ScrollHideHeader from '../components/layout/scrollHideHeader';
import { motion } from 'framer-motion';
import { supabase } from '../supabase';

const History = () => {
  const [historyItems, setHistoryItems] = useState([]);

  useEffect(() => {
    const getHistoryContent = async () => {
      const { data, error } = await supabase
        .from('content_management')
        .select('*')
        .eq('type', 'historyPage');

      if (error) {
        console.error('History content error:', error.message);
        return;
      }

      const sortedData = (data || []).sort((a, b) => {
        const yearA = Number(a.title1);
        const yearB = Number(b.title1);
        return yearA - yearB;
      });

      setHistoryItems(sortedData);
    };

    getHistoryContent();
  }, []);

  const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.2,
        duration: 0.6,
        ease: 'easeOut',
      },
    }),
  };

  const scrollRef = useRef(null);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    let scrollEndTimer = null;
    let locked = false;

    const handleWheel = (e) => {
      if (window.innerWidth < 1024) return;

      const atStart = el.scrollLeft <= 0;
      const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 1;

      if (atStart && e.deltaY < 0) return;
      if (atEnd && e.deltaY > 0) return;

      e.preventDefault();

      if (locked) return;
      locked = true;

      el.scrollBy({ left: e.deltaY * 3, behavior: 'smooth' });

      clearTimeout(scrollEndTimer);

      const unlock = () => {
        locked = false;
        el.removeEventListener('scrollend', unlock);
      };

      if ('onscrollend' in window) {
        el.addEventListener('scrollend', unlock, { once: true });
      } else {
        scrollEndTimer = setTimeout(unlock, 600);
      }
    };

    el.addEventListener('wheel', handleWheel, { passive: false });

    return () => {
      el.removeEventListener('wheel', handleWheel);
      clearTimeout(scrollEndTimer);
    };
  }, []);

  return (
    <>
      <ScrollHideHeader />
      <main>
        <div className="bgDecor"></div>

        <main className="historyMain">
          <h1 className="historyPadding">History</h1>

          <div className="scrollContainer" ref={scrollRef}>
            {historyItems.map((item, index) => (
              <motion.div
                key={item.id || index}
                custom={index}
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                className="flexShrink"
              >
                <div className="scrollItem">
                  <div className="historyTitle">
                    <h1>{item.title1}</h1>
                    <span>- {item.title2}</span>
                  </div>

                  <div className="historyContent">
                    {item.img && (
                      <img className='historyImages'
                        src={item.img}
                        alt={item.title2 || `History ${item.title1}`}
                      />
                    )}
                    <h5>{item.paragraph}</h5>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </main>
      </main>
    </>
  );
};

export default History;